import { ApplicationConfig } from '@angular/core'
import { provideDrrApp } from '../../libs/drrweb-lib/src/lib/shared'
import { environment } from '../environments/environment'
import { routes } from './app.routes'

import {
  I18nTranslations,
  SUPPORTED_LOCALES,
} from 'libs/drrweb-lib/src/lib/shared/i18n/i18n.types'
import translationsFrCa from '../locale/messages.fr-CA.json'
import translationsEn from '../locale/messages.json'

const i18nTranslations: I18nTranslations = {
  [SUPPORTED_LOCALES.EN_US]: translationsEn,
  [SUPPORTED_LOCALES.FR_CA]: translationsFrCa,
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideDrrApp({
      routes,
      environment: {
        ...environment,
        // Published as .js by esbuild/maplibre-worker.plugin.ts: CloudFront serves .mjs as
        // application/octet-stream, which browsers refuse for module workers (DRRWEB-3746).
        maplibreWorkerPath: 'assets/maplibre-gl/maplibre-gl-worker.js',
      },
      i18nTranslations,
    }),
  ],
}
